import { HealthSourceNote } from "@/components/health/HealthSourceInfo";
import { Button } from "@/components/ui/button";
import { Loader2, CheckCircle2 } from "lucide-react";

const ITEMS = [
  "Estimated maintenance calories",
  "Fat-loss or muscle-gain targets",
  "Starting calorie goal",
  "Protein target",
  "Training recommendation",
  "Weekly check-in schedule",
];

export default function StepReady({ onFinish, saving }) {
  return (
    <div className="space-y-6 text-center">
      <div>
        <p className="text-xs uppercase tracking-widest text-muted-foreground font-semibold">
          You&apos;re all set
        </p>
        <h2 className="text-2xl font-heading font-bold mt-2">
          Your TA Fitness profile is ready
        </h2>
        <p className="text-muted-foreground text-sm mt-2">
          We&apos;ll now calculate the following based on your answers:
        </p>
      </div>

      <HealthSourceNote topic="calories" />
      <HealthSourceNote topic="macros" />
      <HealthSourceNote topic="training" />
      <div className="space-y-2 text-left">
        {ITEMS.map((label) => (
          <div key={label} className="flex items-center gap-3 bg-muted/40 rounded-xl px-4 py-2.5">
            <CheckCircle2 className="w-4 h-4 text-primary shrink-0" />
            <span className="text-sm font-medium">{label}</span>
          </div>
        ))}
      </div>

      <Button
        className="w-full h-11 text-base font-semibold"
        onClick={onFinish}
        disabled={saving}
        data-testid="onb-build-plan"
      >
        {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : "Build My Plan"}
      </Button>
    </div>
  );
}
